import { useMemo } from 'react'

import { BootcampGymsListUserData, BootCampItem, BootCampItemGroq } from '~/types/bootcamp'

import { getBootcampProgress } from '~/bootcamp/utils/getBootcampProgress.utils'

export default function useProcessGymsListData(
  bootcampList: BootCampItemGroq[],
  processedData?: BootcampGymsListUserData[],
): BootCampItem[] {
  const result = useMemo(() => {
    return bootcampList?.map<BootCampItem>((res) => {
      const userSubjectData = processedData?.filter(({ key }) => key === res.key)

      const sumOfBootcampsProgress = res.chests?.reduce((prevProgress, bc) => {
        const bcProgress = getBootcampProgress(
          { chests: bc.pages || [], moduleNumber: bc.moduleNumber },
          userSubjectData,
        )
        return prevProgress + bcProgress.progress
      }, 0)

      const subjectProgress = (sumOfBootcampsProgress ?? 0) / res.modules

      // Collected chests in every bootcamp by the user of this gym
      let collectedChestsInBootcampsByModule: Record<string, number> = {}

      // List of boss defeated bootcamps
      let bossDefeatedBootcamps: string[] = []

      if (userSubjectData) {
        userSubjectData.forEach((userBootcampData) => {
          const bootcampKey = userBootcampData.moduleId

          collectedChestsInBootcampsByModule = {
            ...collectedChestsInBootcampsByModule,
            [bootcampKey]: userBootcampData.chests,
          }

          if (userBootcampData.bossDefeated) {
            bossDefeatedBootcamps = [...bossDefeatedBootcamps, bootcampKey]
          }
        })
      }

      const superBadgePartsWithBossData = res.superBadgePartImages.map((subBadge) => ({
        ...subBadge,
        bossDefeated: bossDefeatedBootcamps.includes(subBadge.bootcampNumber),
      }))

      return {
        key: res.key,
        name: res.name,
        modules: res.modules,
        serial: res.serial,
        superBadgeOutlineImage: res.superBadgeOutlineImage,
        superBadgePartImages: superBadgePartsWithBossData,
        hasProgress: bossDefeatedBootcamps.length >= 1,
        progress: subjectProgress,
        tagStatus: res.tagStatus,
        isUpcoming: res.isUpcoming,
      }
    })
  }, [bootcampList, processedData])

  return result
}
